function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs59"
}, /*#__PURE__*/React.createElement("style", {
  id: "style57"
}, ".cls-1{fill:#b0bec5;}.cls-2{fill:#e74b3c;}.cls-3{fill:#607d8b;}.cls-4{fill:#2c3e50;}.cls-5{fill:#ff5722;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", {
  id: "title61"
}, "dopslogowbrand");

var SvgDots = function SvgDots(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 260 260",
    width: 260,
    height: 260,
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", {
    id: "title61"
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -260,
    y: 0.000007390976,
    width: 130,
    height: 130,
    rx: 65,
    ry: 65,
    transform: "rotate(-90)",
    id: "rect63",
    style: {
      fill: "#b0bec5",
      strokeWidth: 2.03125
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -130,
    y: 0.000007390976,
    width: 130,
    height: 130,
    rx: 65,
    ry: 65,
    transform: "rotate(-90)",
    id: "rect65",
    style: {
      fill: "#e74b3c",
      strokeWidth: 2.03125
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -130,
    y: 130.00002,
    width: 130,
    height: 130,
    rx: 65,
    ry: 65,
    transform: "rotate(-90)",
    id: "rect67",
    style: {
      fill: "#607d8b",
      strokeWidth: 2.03125
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -260,
    y: 129.59377,
    width: 130,
    height: 130,
    rx: 65,
    ry: 65,
    transform: "rotate(-90)",
    id: "rect69",
    style: {
      fill: "#2c3e50",
      strokeWidth: 2.03125
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDots, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dots.83854515.svg";
export { ForwardRef as ReactComponent };